import React from 'react';
import { useSelector } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Typography from '@material-ui/core/Typography';
import { RootState } from '../../global';
import { NotificationType } from './notification-types';
import { notificationsSelectors } from './notifications-redux';
import { useNotifications } from './use-notifications';

export const Notifications = () => {
  const notifications = useSelector((state: RootState) =>
    notificationsSelectors.selectAll(state.notifications));

  const notificationsActions = useNotifications();

  function mapNotification(options: NotificationType & { id: string }) {
    return (
      <Snackbar
        key={options.id}
        anchorOrigin={
          options.anchorOrigin ?? { horizontal: 'right', vertical: 'top' }
        }
        open
      >
        <Alert
          onClose={() => {
            notificationsActions.remove(options.id);
          }}
          severity={options.severity}
        >
          <span>
            {options.title && <AlertTitle>{options.title}</AlertTitle>}
          </span>
          <Typography variant="body2">{options.description}</Typography>
        </Alert>
      </Snackbar>
    );
  }

  return <React.Fragment>{notifications.map(mapNotification)}</React.Fragment>;
};
